import BaseClass from "../BaseClass";

/**
 * https://docs.digicert.com/en/certcentral/manage-certificates/digicert-site-seals/install-your-digicert-site-seal.html#add-the--lang--attribute-to-the--div--tag
 */
export class DigicertSiteSeal extends BaseClass {
    constructor(element) {
        super(element);

        this.init();
    }

    init() {
        const tag = this.$element.data('digicert-tag');
        const sealFormat = this.$element.data('digicert-format'); // empty (default), 'dynamic'
        const sealHover = this.$element.data('digicert-seal-hover'); // true/false
        const sealAutoplay = this.$element.data('digicert-seal-autoplay'); // true/false
        const sealUseLogo = this.$element.data('digicert-seal-use-logo'); // true/false
        const sealSize = this.$element.data('digicert-seal-size'); // 's', 'm' (default), 'l'
        const textColor = this.$element.data('digicert-text-color'); // black (default), white
        const sealNumber = this.$element.data('digicert-seal-number'); // 3, 5, 7, 10 (default), 11, 13, 15, 16, 17, 18

        if (this.$element.attr('id') == undefined) {

            this.$element.attr('id', 'DigiCertClickID_' + tag);
        }
        const cid = this.$element.attr('id');

        const sealConfig = {};
        if (tag != undefined) {
            sealConfig.tag = tag;
        }
        if (cid != undefined) {
            sealConfig.cid = cid;
        }
        if (sealFormat != undefined) {
            sealConfig.seal_format = sealFormat;
        }
        if (sealHover != undefined) {
            sealConfig.seal_hover = sealHover;
        }
        if (sealAutoplay != undefined) {
            sealConfig.seal_autoplay = sealAutoplay;
        }
        if (sealUseLogo != undefined) {
            sealConfig.seal_use_logo = sealUseLogo;
        }
        if (sealSize != undefined) {
            sealConfig.seal_size = sealSize;
        }
        if (textColor != undefined) {
            sealConfig.text_color = textColor;
        }
        if (sealNumber != undefined) {
            sealConfig.seal_number = sealNumber;
        }

        window.__dcid = window.__dcid || [];
        window.__dcid.push(sealConfig);

        this.$seal = $('<script />', {async: true, src: '//seal.digicert.eu/seals/cascade/seal.eu.min.js'});

        this.$seal.appendTo('body');
    }
}